// extracted by mini-css-extract-plugin
export default {"feature-flag-rule-value":"feature-flag-rule-value_Td5se"};